/**
 * Waits for a specified number of animation frames before resolving.
 * Prefer this over setTimeout for DOM operations like focusing or measuring.
 */
export function waitForAnimationFrames(count: number): Promise<void> {
  return new Promise((resolve) => {
    let remaining = count;
    function tick(): void {
      remaining--;
      if (remaining <= 0) {
        resolve();
      } else {
        requestAnimationFrame(tick);
      }
    }
    requestAnimationFrame(tick);
  });
}
